import { Effects, loop } from 'redux-loop';
import _ from 'lodash';

import {
  FETCH_GROUPS,
  FETCH_GROUPS_SUCCESS,
  FETCH_USERS,
  FETCH_USERS_SUCCESS,
  UPDATE_USER,
  EMPTY_USERS,
} from './actions';

import { fetchGroups, updateUser, fetchUsers } from './tasks'

const initState = {
  groups: {
    isLoading: false,
    data: {
      entities: {},
      list: []
    },
  },
  users: {
    data: [],
    isLoading: false
  }
}
export default (state=initState, action) => {

  if (action.type === FETCH_GROUPS) {
    return loop({
      ...state,
      groups: {
        ...state.groups,
        isLoading: true,
      }
    }
    ,
      Effects.promise(fetchGroups)
    )
  }

  if (action.type === FETCH_GROUPS_SUCCESS) {
    const obj = _.keyBy(action.data, 'name');
    const list = _.map(action.data, 'name');
    return loop({
      ...state,
      groups: {
        isLoading: false,
        data: {
          ...state.groups.data,
          entities: obj,
          list: list
        }
      }
    },
      Effects.none()
    )
  }

  if (action.type === FETCH_USERS) {
    return loop({
      ...state,
      users: {
        ...state.users,
        isLoading: true,
      }
    },
      Effects.promise(fetchUsers, action.data)
    )
  }

  if (action.type == EMPTY_USERS) {
    return loop({
      ...state,
      users: {
        data: {}
      }
    },
      Effects.none()
    )
  }

  if (action.type === FETCH_USERS_SUCCESS) {
    return loop({
      ...state,
      users: {
        data: action.data,
        isLoading: false,
      }
    },
      Effects.none()
    )
  }

  if (action.type === UPDATE_USER) {
    return loop({
      state,
    }
    ,
      Effects.promise(updateUser, action.data)
    )
  }

  return loop(state, Effects.none());
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/eadmin/reducer.js
 **/